
import { Device } from '../types';
import { mockSmartGasMeters } from '@/lib/mock-data/gas/smart-meters';
import { mockIoTGateways } from '@/lib/mock-data/gas/gateways';
import { allGasDevices } from '@/components/settings/data/gas-devices';
import { 
  convertSmartMeterToDevice, 
  convertGatewayToDevice,
  convertStaticDevicesToGisDevices 
} from './converters';

/**
 * Generate gas devices with real device IDs
 */
export const getGasDevices = (): Device[] => {
  // Process meters and gateways
  const meterDevices = mockSmartGasMeters.map((meter, index) => 
    convertSmartMeterToDevice(meter, 'Gas', index % 20));
  
  const gatewayDevices = mockIoTGateways.map((gateway, index) => 
    convertGatewayToDevice(gateway, 'Gas', index % 10));
  
  // Add static devices from settings
  const staticDevices = convertStaticDevicesToGisDevices(allGasDevices, 20);
  
  return [...meterDevices, ...gatewayDevices, ...staticDevices];
};
